import React, { FunctionComponent } from "react";
import Footnote from "../../../components/Footnote";
import { TooltipWithClose } from "../../../components";

export interface MedigapPlanDetailsTable {
  title: string | JSX.Element;
  footerNotes: { text: string | JSX.Element; id: string; marker?: string }[];
  data: ({
    property: string;
    value:
      | string
      | number
      | JSX.Element
      | ({
          property: string;
          value: string | number | JSX.Element;
          hide?: boolean;
        } | null)[];
    tooltip?: string;
    hide?: boolean;
  } | null)[];
}

interface PlanDetailsTableProps {
  table: MedigapPlanDetailsTable;
}

const PlanDetailsTable: FunctionComponent<PlanDetailsTableProps> = ({
  table,
}) => {
  return (
    <>
      <h2 className="MedigapPlanDetails__tableTitle">{table.title}</h2>

      <div className="MedigapPlanDetails__table">
        {table.data.map((data, i) => {
          return data ? (
            data.hide ? null : (
              <div key={i} className="MedigapPlanDetails__tableRow">
                <div className="MedigapPlanDetails__tableDataProperty">
                  {data.tooltip ? (
                    <TooltipWithClose
                      title={
                        <p className="ds-u-font-size--sm">{data.tooltip}</p>
                      }
                    >
                      {data.property}
                    </TooltipWithClose>
                  ) : (
                    data.property
                  )}
                </div>
                <div className="MedigapPlanDetails__tableDataValue">
                  {Array.isArray(data.value) ? (
                    <ul className="ds-c-list--bare">
                      {data.value.map((v, i) => {
                        if (!v || v.hide) return;

                        return (
                          <li className="ds-u-margin-bottom--2" key={i}>
                            {v.property}: {v.value}
                          </li>
                        );
                      })}
                    </ul>
                  ) : (
                    data.value
                  )}
                </div>
              </div>
            )
          ) : (
            <React.Fragment key={i}></React.Fragment>
          );
        })}

        {!!table.footerNotes.length && (
          <dl>
            {table.footerNotes
              .filter(footnote => !!footnote.text)
              .map((note, i) => (
                <Footnote
                  id={note.id}
                  text={note.text}
                  marker={note.marker}
                  key={i}
                />
              ))}
          </dl>
        )}
      </div>
    </>
  );
};

export default PlanDetailsTable;
